import React, { useContext } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/authConfig';
import { LanguageContext } from '../App';
import { translations } from '../i18n/translations';
import { theme } from '../config/theme';

function Login() {
  const { instance } = useMsal();
  const { language, setLanguage } = useContext(LanguageContext);
  const t = translations[language];

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(console.error);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.langSelector}>
          <button onClick={() => setLanguage('fr')}
            style={language === 'fr' ? styles.langActive : styles.langBtn}>FR</button>
          <button onClick={() => setLanguage('en')}
            style={language === 'en' ? styles.langActive : styles.langBtn}>EN</button>
        </div>
        <div style={styles.logoBox}>
          <div style={styles.logoGrid}>
            {[...Array(9)].map((_, i) => <span key={i} style={styles.logoCell} />)}
          </div>
          <span style={styles.logoText}>HOPSCOTCH</span>
        </div>
        <h1 style={styles.title}>Portail Archives</h1>
        <p style={styles.message}>{t.welcomeMessage}</p>
        <button onClick={handleLogin} style={styles.loginBtn}>
          Se connecter avec mon compte Hopscotch
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: theme.colors.bg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: theme.colors.bgCard,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '12px',
    padding: '48px',
    width: '400px',
    textAlign: 'center',
  },
  langSelector: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '32px',
    gap: '6px',
  },
  langBtn: {
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '3px',
    padding: '3px 8px',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    color: theme.colors.textSecondary,
    fontSize: theme.fonts.size.xs,
  },
  langActive: {
    border: `1px solid ${theme.colors.white}`,
    borderRadius: '3px',
    padding: '3px 8px',
    cursor: 'pointer',
    backgroundColor: theme.colors.white,
    color: theme.colors.textDark,
    fontSize: theme.fonts.size.xs,
    fontWeight: '600',
  },
  logoBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '32px',
  },
  logoGrid: {
    width: '48px',
    height: '48px',
    backgroundColor: theme.colors.white,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: '1fr 1fr 1fr',
    gap: '3px',
    padding: '6px',
    borderRadius: '3px',
  },
  logoCell: {
    backgroundColor: theme.colors.textDark,
    display: 'block',
    borderRadius: '1px',
  },
  logoText: {
    color: theme.colors.white,
    fontSize: theme.fonts.size.xs,
    fontWeight: '600',
    letterSpacing: '0.12em',
  },
  title: {
    fontSize: '22px',
    fontWeight: '500',
    color: theme.colors.textPrimary,
    margin: '0 0 12px 0',
  },
  message: {
    fontSize: theme.fonts.size.lg,
    color: theme.colors.textSecondary,
    marginBottom: '32px',
    lineHeight: '1.6',
  },
  loginBtn: {
    backgroundColor: theme.colors.white,
    color: theme.colors.textDark,
    border: 'none',
    borderRadius: '6px',
    padding: '12px 24px',
    fontSize: theme.fonts.size.base,
    cursor: 'pointer',
    width: '100%',
    fontWeight: '600',
  },
};

export default Login;